// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2d0kf","title":"ClientInsurance_title__334HT","itemText":"ClientInsurance_itemText__1rtQS"};